import { render, staticRenderFns } from "./listsEdit.vue?vue&type=template&id=004c1db2&"
import script from "./listsEdit.vue?vue&type=script&lang=js&"
export * from "./listsEdit.vue?vue&type=script&lang=js&"
import style0 from "./listsEdit.vue?vue&type=style&index=0&id=004c1db2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports